import styled from 'styled-components'

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  label {
    font-weight: var(--font-medium);
    color: var(--brand-secondary);
    display: block;
    font-size: 14px;
    margin-bottom: 6px;

    &.required:before {
      content: ' *';
      color: red;
      margin-right: 3px;
    }
  }

  & > input {
    width: 100%;
  }
`

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`

export const InputLabel = styled.label`
  font-size: 14px;

  &.required:before {
    content: ' *';
    color: red;
  }
`

export const CharCount = styled.span<{ reachedMax: boolean }>`
  font-size: 13px;
  color: var(--text-primary-light);

  ${({ reachedMax }) =>
    reachedMax &&
    `
    color: var(--ui-red);
  `}
`
